<app-title-section></app-title-section>

<div class="card p-1" style="margin-left: 15px; margin-right: 15px">
    <!-- Ligne 1 : Vuexy à gauche / DEVIS à droite -->
    <div class="d-flex justify-content-between align-items-center">
        <!-- Vuexy -->
        <div class="d-flex align-items-center">
            <ng-container *ngIf="isTitleVisible">
                <img [src]="file" class="logo-img me-2">
                <p style="font-size: 22px;color: #2F2B3DE5">Vuexy</p>
            </ng-container>
            <button class="btn-icon-eye">
                <i [attr.data-feather]="isTitleVisible ? 'eye-off' : 'eye'"
                   style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
            </button>
        </div>

        <h4 *ngIf="!bonTransfert" style="font-size: 20px; color: #2F2B3DE5; font-weight: 600;">Inventaire</h4>
        <h4 *ngIf="bonTransfert" style="font-size: 20px; color: #2F2B3DE5; font-weight: 600;">BON DE TRANSFERT</h4>


    </div>

    <div class="items mt-4">
        <div class="flex-grow-1">

        </div>
        <!-- Partie Détails du document -->
        <div class=" " style="width: 980px">
            <p class="size15" style="color: #2F2B3DE5"><strong>Détails du document </strong></p>
            <hr class="section-line" style="color:#134AD3">

            <!-- Date -->
            <div class="form-group mb-2 align-items-center">
                <div class="row">
                    <div class="col-12">
                        <label class="size13">Date</label>
                    </div>
                    <div class="col-12 d-flex align-items-start">
                        <ng2-flatpickr
                                name="basicDate"
                                [config]="basicDateOptions"
                                [(ngModel)]="documentDate"
                                style="width: 100%;"
                                [disabled]="isDateReadonly">
                        </ng2-flatpickr>

                        <button class="btn-icon-eye ms-2" (click)="toggleReadonly('date')">
                            <i [attr.data-feather]="isDateReadonly ? 'eye' : 'eye-off'"
                               style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Entrepôt -->
            <div *ngIf="!entrpotInit" class="form-group mb-2 align-items-center">
                <div class="row">
                    <div class="col-12">
                        <label class="size13">Entrepôt</label>
                    </div>
                    <div class="col-12 d-flex align-items-start">
                        <select [(ngModel)]="selectedEntrepot" class="form-control" [disabled]="isEntrepotReadonly">
                            <option value="">Choisissez un Entrepôt</option>
                            <option *ngFor="let entrepot of allEntrepot"
                                    [ngValue]="entrepot.id">
                                {{ entrepot.nom }}
                            </option>
                        </select>
                        <button class="btn-icon-eye ms-2" (click)="toggleReadonly('entrepot')">
                            <i [attr.data-feather]="isEntrepotReadonly ? 'eye' : 'eye-off'"
                               style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                        </button>
                    </div>
                </div>
            </div>
            <!-- Entrepôt initial -->
            <div *ngIf="entrpotInit" class="form-group mb-2 align-items-center">
                <div class="row">
                    <div class="col-12">
                        <label class="size13">Entrepôt initial</label>
                    </div>
                    <div class="col-12 d-flex align-items-start">
                        <select [(ngModel)]="selectedEntrepot" class="form-control" [disabled]="isEntrepotReadonly">
                            <option value="">Choisissez un Entrepôt</option>
                            <option></option>
                        </select>
                        <button class="btn-icon-eye ms-2" (click)="toggleReadonly('entrepot')">
                            <i [attr.data-feather]="isEntrepotReadonly ? 'eye' : 'eye-off'"
                               style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Entrepôt destination -->
            <div *ngIf="entrpotInit" class="form-group mb-2 align-items-center">
                <div class="row">
                    <div class="col-12">
                        <label class="size13">Entrepôt destination</label>
                    </div>
                    <div class="col-12 d-flex align-items-start">
                        <select [(ngModel)]="selectedEntrepot" class="form-control" [disabled]="isEntrepotReadonly">
                            <option value="">Choisissez un Entrepôt</option>
                            <option></option>
                        </select>
                        <button class="btn-icon-eye ms-2" (click)="toggleReadonly('entrepot')">
                            <i [attr.data-feather]="isEntrepotReadonly ? 'eye' : 'eye-off'"
                               style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                        </button>
                    </div>
                </div>
            </div>


            <!-- Projet -->
            <div class="form-group mb-2 align-items-center">
                <div class="row">
                    <div class="col-12">
                        <label class="size13">Projet</label>
                    </div>
                    <div class="col-12 d-flex align-items-start">
                        <select style="height: 40px" [(ngModel)]="selectedProject" class="form-control"
                                [disabled]="isProjectReadonly">
                            <option value="">Choisissez un projet</option>
                            <option *ngFor="let project of projects" [value]="project.id">{{ project.libelle }}</option>
                        </select>
                        <button type="button" class="add-button ms-2" (click)="openAjoutModal()">
                            <span data-feather="plus"></span>
                        </button>
                        <button class="btn-icon-eye ms-2" (click)="toggleReadonly('project')">
                            <i [attr.data-feather]="isProjectReadonly ? 'eye' : 'eye-off'"
                               style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Note -->
            <div class="form-group mb-2">
                <label class="size13">Note</label>
                <div class="d-flex align-items-center">
                    <input
                            type="text"
                            class="form-control"
                            placeholder="Enter note"
                            [(ngModel)]="note"
                            [readonly]="isNoteReadonly"/>
                    <button class="btn-icon-eye ms-2" (click)="toggleReadonly('note')">
                        <i [attr.data-feather]="isNoteReadonly ? 'eye' : 'eye-off'"
                           style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                    </button>
                </div>
            </div>


            <div class=" mb-2" *ngFor="let field of customFields; let i = index">
                <!-- Input pour le label -->
                <div class="items2 ">
                    <div class="mr-1" style="width: 30%">
                        <input
                                type="text"
                                class="form-control mb-1"
                                [(ngModel)]="field.label"
                                placeholder="Nom du champ (ex: Référence, Numéro série...)"/>
                    </div>

                    <div class="" style="width: 100%">
                        <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="field.value"
                                placeholder="Entrer {{ field.label || 'valeur' }}"/>

                    </div>
                    <div class="mt-1 mb-2 ">
                        <button class=" unstyled-btn" (click)="removeField(i)">
                            <i data-feather="trash-2" [size]="22" class="text-danger cursor-pointer"></i>
                        </button>
                    </div>

                </div>

            </div>
            <!-- Bouton Ajouter -->
            <button class="btn btn-primary" (click)="addField()"> Ajouter Un Champ</button>
        </div>
    </div>


    <div class="products-section">
        <table class="products-table table-bordered">
            <thead>
            <tr>
                <th>DÉSIGNATION</th>
                <th>QUANTITÉ</th>
                <th>QUANTITÉ DISPONIBLE</th>
                <th> VALEUR UNITAIRE</th>
                <th>TOTAL HT</th>
                <th style="text-align: center" class="pl-1"></th>

            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let item of items; let i = index">
                <ng-container [ngSwitch]="item.type">
                    <!-- Product Row -->
                    <ng-container *ngSwitchCase="'product'">
                        <tr>
                            <td class="table-input">
                                <ng-select
                                        [items]="products"
                                        bindLabel="nom"
                                        bindValue="nom"
                                        [(ngModel)]="item.designation"
                                        [ngModelOptions]="{standalone: true, updateOn: 'change'}"
                                        (change)="onProductSelect(i, $event)"
                                        [clearable]="true"
                                        [searchable]="true"
                                        class="ng-select-custom"
                                        [disabled]="isLoadingProducts"
                                        style="width: 300px"
                                >
                                    <ng-template ng-option-tmp let-item="item">
                                        <div class="d-flex align-items-center justify-content-between"
                                             data-debug="option-{{item.nom}}">
                                            <div class="d-flex align-items-center">
                                                <img
                                                        [src]="item.image"
                                                        [class.d-none]="!item.image"
                                                        class="logo-product"
                                                        style="margin: 0 auto;"
                                                        alt="{{ item.nom }}"
                                                />
                                                <span class="product-name">{{ item.nom }}</span>
                                            </div>
                                            <span class="badge" [ngClass]="{'badge-tous': (item.quantity ?? 0) < 1, 'badge-en-stok': (item.quantity ?? 0) >= 1}">
                            {{ item.quantity ?? 0 }} : {{ (item.quantity ?? 0) < 1 ? 'En rupture' : 'En stock' }}
                        </span>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item">
                                        <ng-container *ngIf="item && item.nom; else placeholderTemplate">
                                            <div class="d-flex align-items-center justify-content-center"
                                                 data-debug="selected-{{item.nom}}">
                                                <!--    <img [src]="item.image"
                                                        class="logo-product"
                                                        (error)="handleImageError($event)"
                                                        style="margin: 0 auto;"
                                                   />
                                                   Changed from item.name to item.nom -->
                                                <span>{{ item.nom }}</span>
                                            </div>
                                        </ng-container>
                                        <ng-template #placeholderTemplate>
                        <span class="ng-placeholder" data-debug="placeholder"
                              style="display: block; text-align: center;">Sélectionnez la désignation</span>
                                        </ng-template>
                                    </ng-template>
                                </ng-select>
                            </td>
                            <!-- Rest of your code remains the same -->
                            <td *ngIf="item.designation" class="table-input">
                                <input
                                        type="number"
                                        class="form-control"
                                        [(ngModel)]="item.quantity"
                                        placeholder="0"
                                        (input)="calculateTotal(i)"
                                />
                            </td>
                            <td *ngIf="item.designation" class="table-input">
                                <input
                                        type="number"
                                        class="form-control"
                                        [(ngModel)]="item.priceHT"
                                        placeholder="0.000"
                                        (input)="calculateTotal(i)"
                                />
                            </td>
                            <td *ngIf="item.designation" class="table-input">
                                <input type="number"
                                       [(ngModel)]="item.prix_unitaires"
                                       class="form-control"
                                />
                            </td>
                            <td *ngIf="item.designation" class="table-input">
                                {{ item.totalHT | number:'1.3-3' }} TND
                            </td>
                            <td *ngIf="!item.designation" colspan="4" class="table-input"></td>
                            <td class="table-inputs">
                                <a (click)="removeItem(i)">
                                    <span data-feather="trash-2" [size]="22" class="text-danger cursor-pointer"></span>
                                </a>
                            </td>
                        </tr>
                    </ng-container>
                    <!-- Text Row -->
                    <ng-container *ngSwitchCase="'text'">
                        <tr>
                            <td colspan="5" class="table-input">
                    <textarea
                            [(ngModel)]="item.content"
                            class="form-control"
                            placeholder="Ajoutez un texte"

                    ></textarea>
                            </td>
                            <td style="padding: 4px; text-align: center; vertical-align: middle; border-bottom: 1px solid #ced4da; border-left: none; border-right: none;">
                                <a (click)="removeItem(i)">
                                    <span data-feather="trash-2" [size]="22" class="text-danger cursor-pointer"></span>
                                </a>
                            </td>
                        </tr>
                    </ng-container>
                    <!-- Heading Row -->
                    <ng-container *ngSwitchCase="'heading'">
                        <tr>
                            <td colspan="5" sclass="table-input">
                                <input
                                        [(ngModel)]="item.content"
                                        type="text"
                                        class="form-control"
                                        placeholder="Ajoutez une rubrique"
                                        style="border: 1px solid #ced4da; width: 100%; margin: 0 auto; text-align: start;"
                                />
                            </td>
                            <td style="padding: 4px; text-align: center; vertical-align: middle; border-bottom: 1px solid #ced4da; border-left: none; border-right: none;">
                                <a (click)="removeItem(i)">
                                    <span data-feather="trash-2" [size]="22" class="text-danger cursor-pointer"></span>
                                </a>
                            </td>
                        </tr>
                    </ng-container>
                    <!-- Separator Row -->
                    <ng-container *ngSwitchCase="'separator'">
                        <tr>
                            <td colspan="5" class="table-input">
                                <div style="border-top: 2px solid #134ADB; width: 100%; margin: 4px 0;"></div>
                            </td>
                            <td style="padding: 4px; text-align: center; vertical-align: middle; border-bottom: none; border-left: none; border-right: none;">
                                <a (click)="removeItem(i)">
                                    <span data-feather="trash-2" [size]="22" class="text-danger cursor-pointer"></span>
                                </a>
                            </td>
                        </tr>
                    </ng-container>
                    <!-- Subtotal Row -->
                    <ng-container *ngSwitchCase="'subtotal'">
                        <tr>
                            <td colspan="4"
                                style="padding: 4px; border-bottom: 1px solid #ced4da; border-left: none; border-right: none;"></td>
                            <td style="padding: 4px; text-align: center; vertical-align: middle; border-bottom: 1px solid #ced4da; border-left: none; border-right: none;">
                                <div style="font-size: 14px; font-weight: 400; color: rgba(47, 43, 61, 0.7); text-align: center;">
                                    Sous-total
                                </div>
                                <div style="font-size: 14px; font-weight: 400; color: rgba(47, 43, 61, 0.9); text-align: center;">
                                    {{ item.subTotal | number:'1.3-3' }} TND
                                </div>
                            </td>
                            <td style="padding: 4px; text-align: center; vertical-align: middle; border-bottom: 1px solid #ced4da; border-left: none; border-right: none;">
                                <a (click)="removeItem(i)">
                                    <span data-feather="trash-2" [size]="22" class="text-danger cursor-pointer"></span>
                                </a>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </ng-container>
            </tbody>
        </table>

        <div ngbDropdown class="btn-group">
            <button class="btn btn-primary" (click)="addItems('product')" rippleEffect> Ajouter Un Produit</button>
            <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle-split"
                    rippleEffect>
                <span class="sr-only"><p style="margin: 4px 10px;">Toggle Dropdown</p></span>
            </button>
            <div ngbDropdownMenu>
                <a ngbDropdownItem href="javascript:void(0)" (click)="addItems('code_bar')">Scanner des codes à
                    barres</a>
                <a ngbDropdownItem href="javascript:void(0)" (click)="addItems('text')">Ajouter un texte</a>
                <a ngbDropdownItem href="javascript:void(0)" (click)="addItems('heading')">Ajouter une rubrique</a>
                <a ngbDropdownItem href="javascript:void(0)" (click)="addItems('separator')">Ajouter un séparateur</a>
                <a ngbDropdownItem href="javascript:void(0)" (click)="addItems('subtotal')">Ajouter un sous-total</a>
            </div>
        </div>


    </div>

    <!-- Footer Info -->
    <div class="footer-info d-flex justify-content-between">
        <div class="company-info">
            <p style="font-size: 15px;"><strong>Entreprise </strong></p>
            <p class="information">Shopi</p>
            <p class="information">l'aouina cité wahat, tunis</p>
            <p class="information">null tunis</p>
            <p class="information">Matricule fiscal: 5885</p>
        </div>
        <div class="coordinates">
            <p style="font-size: 15px;"><strong> Coordonnées </strong></p>
            <p class="information">--</p>
            <p class="information">--</p>
        </div>
        <div class="bank-info">
            <p style="font-size: 15px"><strong> Coordonnées bancaires </strong></p>
            <p class="information">STB-Société Tunisienne de Banque</p>
            <p class="information">TN5910006035183509478831</p>
        </div>
    </div>


</div>


<app-ajout-projet #projectModal
                  [clientId]="clientId"
                  [stationId]="stationId"
                  (projectSaved)="onProjectSaved()"
                  #ajout></app-ajout-projet>
